import { notify } from '@/helpers/notify' 
import moment from 'moment';

var myMixin = {
  methods: {
    formatTL(price) {
      if(!price) return price
      var currency_symbol = "₺"
      var formattedOutput = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY',
          minimumFractionDigits: 2,
        });
      return formattedOutput.format(price).replace(currency_symbol, '') + ' TL'
    },
    async copyURL(copyText) {
      try {
        await navigator.clipboard.writeText(copyText);
        notify.toast('Kopyalandı')
      } catch (_) {
          // eslint-disable-next-line no-console
          console.warn('Kopyalama Başarısız:' + _ )
      }
    },
    formatBytes(bytes,decimals){
      if(!bytes || bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    secondsToDhms(seconds){
      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600*24));
      var h = Math.floor(seconds % (3600*24) / 3600);
      var m = Math.floor(seconds % 3600 / 60);
      var s = Math.floor(seconds % 60);
      
   
      let dDisplay;
      if (s > 0) dDisplay = s + " saniye"
      if (m > 0) dDisplay = m + " dakika"
      if (h > 0) dDisplay = h + " saat" 
      if (d > 0) dDisplay = d + " gün" 

      return dDisplay
    },
    formatDate(value,format = "DD.MM.YYYY"){
      moment.locale('tr-TR');
      return value ? moment(value).format(format) : '';  
		},
  }
}

export default myMixin